import { BrowserStorageAdapter } from "./BrowserStorageAdapter";
import { ServerStorageAdapter } from "./ServerStorageAdapter";
import { StorageAdapter } from "./StorageAdapter";

export function createStorageAdapter(): StorageAdapter {
    // 只要判断是否在浏览器端 或者 服务端
    if ( typeof window === "undefined" ) {
        return new ServerStorageAdapter();
    }
    return new BrowserStorageAdapter();
}

export type { StorageAdapter } from "./StorageAdapter";
